// @ts-nocheck
import React from 'react';

import { Slider as SliderAntd } from 'antd';
import './Slider.sass';

export const Slider = (props: any) => {

	return (
		<div className={'SliderWrapper ' + (props.readOnly ? 'readonly' : '')} onClick={props.onClick}>
			{props.readOnly ? (
				<SliderAntd
					min={0}
					disabled={props.readOnly ? props.readOnly : false}
					max={100}
					step={10}
					onAfterChange={(value) => {
						if (props.onChange) props.onChange(value);
					}}
					defaultValue={props.value || 0}
					value={props.readOnly ? props.value : undefined}
					tooltip={{ open: false }}
				/>
			) : (
				<SliderAntd
					min={0}
					max={100}
					step={10}
					onAfterChange={(value) => {
						if (props.onChange) props.onChange(value);
					}}
					defaultValue={props.value || 0}
					tooltip={{ open: false }}
				/>
			)}
		</div>
	);
};

// <animated.div style={{ transform: `translate3d(${x}px,-5px,0)` }}>	</animated.div>
